/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { BurstMode, Cancel, CloudUpload, Delete, Edit, Mic, PictureAsPdf, Videocam } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { uploadManually } from 'src/services';
import { UPLOAD_MEDIA } from 'src/services/paths';
import { getMedia } from 'src/utils/getImage';
import { UploadManual } from './dialog/UploadManual';

export const Uploader = ({
  defaultMedia,
  media,
  setMedia,
  defaultSetting,
  error,
  properties: propertiesAction,
  setProperties: setPropertiesAction,
}) => {
  const ref = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const courseID = useSelector((state) => state.course.courseID);
  const [previewMedia, setPreviewMedia] = useState(defaultSetting?.multi ? [] : undefined);

  const type = propertiesAction?.type?.value;

  useEffect(() => {
    setPreviewMedia(defaultMedia);
  }, [defaultMedia]);

  const [settings, setSettings] = useState({
    ...defaultSetting,
    title: 'آپلود فایل',
    action: () => {},
    icon: <CloudUpload />,
    multi: false,
    accept: '/*',
  });

  const [properties, setProperties] = useState(
    propertiesAction ?? {
      title: '',
      type: {},
      content: '',
      html: '',
      slideHashes: [],
      uploadManually: false,
      dewcription: '',
      manual: {
        courseID,
        size: 0,
        videoName: '',
        videoUrl: '',
        mimeType: 'video/mp4',
      },
      medias: [],
    }
  );

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [openManual, setOpenManual] = useState(false);
  const [manualLoading, setManualLoading] = useState(false);

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const localUrl = URL.createObjectURL(file);
    if (defaultSetting?.multi) {
      setPreviewMedia((prev) => [...(prev || []), localUrl]);
    } else {
      setPreviewMedia(localUrl);
    }

    const body = new FormData();
    body.append('media', file);
    body.append('mediaType', type);
    body.append('courseID', courseID);
    setLoading(true);

    try {
      const response = await axios.post(UPLOAD_MEDIA, body, {
        timeout: 0,
        onUploadProgress: (e) => {
          const percent = e.progress * 99;
          setProgress(percent);
          if (e.loaded === e.total) {
            setProgress(0);
            setLoading(false);
          }
        },
      });

      const mediaHash = response.data.mediaHash;

      if (propertiesAction?.type?.value === 0) {
        setPropertiesAction((prev) => ({
          ...prev,
          slideHashes: [...prev.slideHashes, mediaHash],
        }));
      } else if ([1, 2].includes(propertiesAction?.type?.value)) {
        setPropertiesAction((prev) => ({
          ...prev,
          content: mediaHash,
        }));
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('خطا در بارگذاری فایل - لطفا مجددا تلاش کنید', { variant: 'error' });
      setProgress(0);
      setLoading(false);
    }
  };

  const onDeleteSlide = (hash) => {
    const findHashIndex = propertiesAction?.slideHashes?.findIndex((sh) => sh === hash);
    const slideHashes = [
      ...propertiesAction?.slideHashes?.slice(0, findHashIndex),
      ...propertiesAction?.slideHashes?.slice(findHashIndex + 1),
    ];
    setPropertiesAction?.({ ...properties, slideHashes });
  };
  const onCancelUpload = () => {
    window.stop();
  };

  useEffect(() => {
    switch (type) {
      case 0:
        setSettings((prevState) => ({
          ...prevState,
          title: settings.multi ? 'آپلود تصاویر' : 'آپلود تصویر',
          icon: <BurstMode />,
          action: () => {},
          accept: 'image/*',
        }));
        break;
      case 1:
        setSettings((prevState) => ({
          ...prevState,
          title: 'آپلود صدا',
          icon: <Mic />,
          action: () => {},
          accept: 'audio/*',
        }));
        break;
      case 2:
        setSettings((prevState) => ({
          ...prevState,
          title: 'آپلود ویدیو',
          icon: <Videocam />,
          action: () => {},
          accept: 'video/*',
        }));
        break;
      case 3:
        setSettings((prevState) => ({
          ...prevState,
          title: 'آپلود PDF',
          icon: <PictureAsPdf />,
          action: () => {},
          accept: 'application/pdf',
        }));
        break;
      default:
        break;
    }
    setFile(null);
  }, [type]);

  const onUploadManual = async () => {
    if (type !== 2) return;
    setManualLoading(true);
    try {
      const response = await uploadManually(properties.manual);
      setMedia?.(response.data.mediaHash);
      setPropertiesAction((prevState) => ({
        ...prevState,
        slideHashes: [...properties?.slideHashes, response.data.mediaHash],
      }));
      setOpenManual(false);
      setManualLoading(false);
    } catch (error) {
      enqueueSnackbar('خطا در بارگذاری دستی ویدیو', { variant: 'error' });
      setManualLoading(false);
    }
  };

  const renderPreview = () => {
    const preview = previewMedia ?? defaultSetting?.multi ? media : getMedia(media);

    switch (type) {
      case 0:
        return (
          <Grid container spacing={3} sx={{ mt: 'auto' }}>
            {propertiesAction?.slideHashes?.map((src, index) => (
              <Grid key={index} item xs={12} md={3}>
                <Tooltip
                  title={
                    <IconButton onClick={() => onDeleteSlide(src)}>
                      <Delete color="error" />
                    </IconButton>
                  }
                >
                  <img
                    src={src.includes('blob') ? src : getMedia(src)}
                    alt={''}
                    style={{ aspectRatio: 3 / 1, width: '100%', objectFit: 'cover' }}
                  />
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        );
      case 1:
        return <audio controls autoPlay style={{ margin: '1rem 0' }} src={getMedia(propertiesAction?.content)} />;
      case 2:
        return (
          <>
            <video
              width="320"
              height="240"
              autoPlay
              controls
              src={getMedia(propertiesAction?.content)}
              style={{ margin: '1rem 0' }}
            />
            <TextField
              label={'توضیحات'}
              fullWidth
              multiline
              minRows={3}
              value={propertiesAction.description}
              onChange={(e) => setPropertiesAction((prev) => ({ ...prev, description: e.target.value }))}
              inputProps={{ maxLength: 2000 }}
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment position="end" sx={{ position: 'absolute', right: 10, bottom: 15}}>
              //       <Typography variant="caption" fontSize={12}>
              //         {`${description.length}/2000`}
              //       </Typography>
              //     </InputAdornment>
              //   )
              // }}
            />
          </>
        );
      case 3:
        return (
          preview && (
            <iframe
              title="PDF FILE"
              src={typeof preview === 'string' ? preview : getMedia(preview)}
              style={{ border: '1px solid rgba(0, 0, 0, 0.3)', height: '550px', width: '100%', marginTop: '12px' }}
            />
          )
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Stack sx={{ ...boxStyles, border: `1px dashed ${error ? '#FF4842' : '#774c9e80'}` }}>
        <Tooltip
          title={
            <Button onClick={onCancelUpload} endIcon={<Cancel color="error" />}>
              <Typography fontSize={14} color="white" sx={{ mx: 1 }}>
                لغو بارگذاری
              </Typography>
            </Button>
          }
          open={loading}
          arrow
        >
          {progress > 0 ? (
            <Button size="large" variant="contained" sx={{ width: 150 }}>
              <CircularProgressWithLabel value={progress} size={36} />
            </Button>
          ) : (
            <Button
              variant="contained"
              size="large"
              endIcon={settings.icon}
              onClick={() => ref.current.click()}
              disabled={properties?.uploadManually}
            >
              {settings.title}
            </Button>
          )}
        </Tooltip>

        {type === 2 && (
          <>
            <Divider variant="fullWidth" sx={{ my: 3, borderColor: 'red' }}>
              <Typography>یا</Typography>
            </Divider>
            <div>
              {properties?.uploadManually && (
                <IconButton onClick={() => setOpenManual(true)}>
                  <Edit />
                </IconButton>
              )}
              <FormControlLabel
                control={
                  <Switch
                    checked={properties?.uploadManually}
                    onChange={() => {
                      setOpenManual(openManual ? false : true);
                      setProperties({
                        ...properties,
                        uploadManually: properties?.uploadManually ? false : true,
                        content: '',
                        html: '',
                        slideHashes: [],
                      });
                      setPropertiesAction?.({
                        ...properties,
                        uploadManually: properties?.uploadManually ? false : true,
                        content: '',
                        html: '',
                        slideHashes: [],
                      });
                    }}
                  />
                }
                label="بارگذاری دستی"
              />
            </div>
            <UploadManual
              open={openManual}
              onClose={() => {
                setOpenManual(false);
              }}
              manually={properties}
              setManually={setProperties}
              action={onUploadManual}
              loading={manualLoading}
            />
          </>
        )}

        {renderPreview()}

        <input
          type="file"
          ref={ref}
          hidden
          accept={settings.accept}
          onChange={onUpload}
          onClick={(e) => (e.currentTarget.value = null)}
        />
      </Stack>
    </>
  );
};
Uploader.propTypes = {
  type: PropTypes.number.isRequired,
};

export const boxStyles = {
  width: '100%',
  minHeight: 300,
  height: '100%',
  px: 3,
  py: 5,
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" color="inherit" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="white">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
